import { TimeOptions } from 'src/types/date-time.types';

export const getCurrentTime = (date?: Date) => {
  const now = date ?? new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const isAM = currentHour < 12;
  const period = isAM ? 'am' : 'pm';
  const formattedHours = [0, 12].includes(currentHour)
    ? '12'
    : (currentHour % 12).toString();
  return {
    hours: formattedHours,
    minutes:
      currentMinute < 10 ? `0${currentMinute}` : currentMinute.toString(),
    period,
  };
};

export const formatDate = (date: Date, showTime?: boolean): string => {
  const dayOptions = {
    month: 'long',
    day: 'numeric',
  };
  const timeOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };
  let options = dayOptions;
  if (showTime) {
    options = {
      ...dayOptions,
      ...timeOptions,
    };
  }

  const formattedDate = date
    .toLocaleString('en-US', options as any)
    .replace(',', '')
    .toLowerCase();
  const prettifiedDate =
    formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
  return prettifiedDate;
};

export const getDateWithCustomTime = (
  date: Date,
  customTime?: TimeOptions
): Date => {
  if (!customTime) {
    return date;
  }
  const { hours, minutes, period } = customTime;
  const timeString = `${hours}:${minutes}:00 ${period}`;
  const dayString = date.toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
  return new Date(`${dayString} ${timeString}`);
};

export const isTomorrow = (date: Date) => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  return (
    date.getFullYear() === tomorrow.getFullYear() &&
    date.getMonth() === tomorrow.getMonth() &&
    date.getDate() === tomorrow.getDate()
  );
};
